import axios from 'axios';

// 创建axios实例
const service = axios.create({
  // baseURL: "https://www.penya-sports.com",
  baseURL: "//www.pysport.cn",
  // baseURL: "http://pysport.com",
  timeout: 30000, // 响应时长
});
// // 请求拦截器
// service.interceptors.request.use(
//   config => {
//     // 在发送请求之前做些什么（如添加全局请求头、预处理参数等）
//     return config;
//   },
//   error => {
//     // 对请求错误做些什么（如统一错误提示、取消重复请求等）
//     return Promise.reject(error);
//   }
// );

// // 响应拦截器
// service.interceptors.response.use(
//   response => {
//     // 对响应数据做些什么（如统一处理状态码、数据格式化等）
//     const res = response.data;
//     if (res.code !== 200) {
//       // 处理非200状态码
//       return Promise.reject(res.message || 'Error');
//     } else {
//       return res.data;
//     }
//   },
//   error => {
//     // 对响应错误做些什么（如网络错误、服务器错误等）
//     console.error('请求失败:', error); // 打印到控制台便于调试
//     return Promise.reject(error);
//   }
// );
export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js